"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.LoginForm = void 0;
Object.defineProperty(exports, "tryLogin", {
  enumerable: true,
  get: function get() {
    return _tryLogin.tryLogin;
  }
});

var _react = _interopRequireWildcard(require("react"));

var _localforage = _interopRequireDefault(require("localforage"));

var _ = require("../../");

var _Loading = require("../../molecules/Loading");

var _atoms = require("../../atoms");

var _EnterCodeForm = require("./EnterCodeForm");

var _LoginMagicForm = require("./LoginMagicForm");

var _ShadowLoginMagicForm = require("./ShadowLoginMagicForm");

var _tryLogin = require("./tryLogin");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

var LoginForm = function LoginForm(_ref) {
  var width = _ref.width,
      center = _ref.center,
      loading = _ref.loading,
      onSuccess = _ref.onSuccess,
      onFailure = _ref.onFailure,
      redirectURL = _ref.redirectURL,
      children = _ref.children;

  var _useState = (0, _react.useState)(false),
      _useState2 = _slicedToArray(_useState, 2),
      lastEmailLoaded = _useState2[0],
      setLastEmailLoaded = _useState2[1];

  var _useState3 = (0, _react.useState)('loading'),
      _useState4 = _slicedToArray(_useState3, 2),
      step = _useState4[0],
      setStep = _useState4[1];

  var _useState5 = (0, _react.useState)(''),
      _useState6 = _slicedToArray(_useState5, 2),
      generalError = _useState6[0],
      setGeneralError = _useState6[1];

  var _useState7 = (0, _react.useState)(false),
      _useState8 = _slicedToArray(_useState7, 2),
      forShadowUser = _useState8[0],
      setForShadowUser = _useState8[1];

  var _useState9 = (0, _react.useState)(null),
      _useState10 = _slicedToArray(_useState9, 2),
      shadowUserId = _useState10[0],
      setShadowUserId = _useState10[1];

  var _useState11 = (0, _react.useState)(null),
      _useState12 = _slicedToArray(_useState11, 2),
      shadowEmailHash = _useState12[0],
      setShadowEmailHash = _useState12[1];

  var _useState13 = (0, _react.useState)(false),
      _useState14 = _slicedToArray(_useState13, 2),
      didGetShadowUserId = _useState14[0],
      setDidGetShadowUserId = _useState14[1];

  var _useState15 = (0, _react.useState)(false),
      _useState16 = _slicedToArray(_useState15, 2),
      didGetShadowUserEmailHash = _useState16[0],
      setDidGetShadowUserEmailHash = _useState16[1];

  var _useState17 = (0, _react.useState)(''),
      _useState18 = _slicedToArray(_useState17, 2),
      email = _useState18[0],
      _setEmail = _useState18[1];

  var _useState19 = (0, _react.useState)(''),
      _useState20 = _slicedToArray(_useState19, 2),
      emailError = _useState20[0],
      setEmailError = _useState20[1];

  var _useState21 = (0, _react.useState)(''),
      _useState22 = _slicedToArray(_useState21, 2),
      code = _useState22[0],
      setCode = _useState22[1];

  var _useState23 = (0, _react.useState)(''),
      _useState24 = _slicedToArray(_useState23, 2),
      codeError = _useState24[0],
      setCodeError = _useState24[1];

  (0, _react.useEffect)(function () {
    if (email === '' && lastEmailLoaded === false) {
      setLastEmailLoaded(true);
      getLastLoginEmail().then(function (val) {
        if (val) {
          _setEmail(val);
        }
      });
    }
  }, [email, lastEmailLoaded]);
  (0, _react.useEffect)(function () {
    getShadowUserId().then(function (val) {
      if (val) {
        setShadowUserId(val);
      }

      setDidGetShadowUserId(true);
    });
    getShadowUserEmailHash().then(function (val) {
      if (val) {
        setShadowEmailHash(val);
      }

      setDidGetShadowUserEmailHash(true);
    });
  }, []);
  (0, _react.useEffect)(function () {
    if (shadowEmailHash && shadowUserId && didGetShadowUserId && didGetShadowUserEmailHash) {
      setForShadowUser(true);
      setStep('shadow-login-magic');
    } else if (didGetShadowUserId && didGetShadowUserEmailHash && (!shadowEmailHash || !shadowUserId)) {
      setStep('login-magic');
    }
  }, [shadowUserId, shadowEmailHash, didGetShadowUserId, didGetShadowUserEmailHash]);
  var theStep = loading ? 'loading' : step;
  var styles = {
    minHeight: '200px',
    justifyContent: 'center'
  };

  if (width) {
    styles.maxWidth = width;
  }

  if (center) {
    styles.margin = '0 auto';
  }

  return /*#__PURE__*/_react.default.createElement(_.StepController, {
    trkContext: "Login Form",
    step: theStep
  }, /*#__PURE__*/_react.default.createElement(_.Step, {
    name: "loading"
  }, /*#__PURE__*/_react.default.createElement(_atoms.Column, {
    center: true,
    style: styles
  }, /*#__PURE__*/_react.default.createElement(_Loading.Loading, null))), /*#__PURE__*/_react.default.createElement(_.Step, {
    name: "login-magic"
  }, /*#__PURE__*/_react.default.createElement(_LoginMagicForm.LoginMagicForm, {
    width: width,
    center: center,
    redirectURL: redirectURL,
    generalError: generalError,
    setGeneralError: setGeneralError,
    setStep: setStep,
    email: email,
    setEmail: function setEmail(email) {
      setLastLoginEmail(email);

      _setEmail(email);
    },
    emailError: emailError,
    setEmailError: setEmailError
  }, children)), /*#__PURE__*/_react.default.createElement(_.Step, {
    name: "shadow-login-magic"
  }, /*#__PURE__*/_react.default.createElement(_ShadowLoginMagicForm.ShadowLoginMagicForm, {
    width: width,
    center: center,
    redirectURL: redirectURL,
    generalError: generalError,
    setGeneralError: setGeneralError,
    setStep: setStep,
    email: email,
    setEmail: function setEmail(email) {
      setLastLoginEmail(email);

      _setEmail(email);
    },
    emailError: emailError,
    setEmailError: setEmailError,
    userId: shadowUserId,
    emailHash: shadowEmailHash
  }, children)), /*#__PURE__*/_react.default.createElement(_.Step, {
    name: "enter-code"
  }, /*#__PURE__*/_react.default.createElement(_EnterCodeForm.EnterCodeForm, {
    forShadowUser: forShadowUser,
    width: width,
    center: center,
    generalError: generalError,
    setGeneralError: setGeneralError,
    email: email,
    setStep: setStep,
    code: code,
    setCode: setCode,
    codeError: codeError,
    setCodeError: setCodeError,
    onSuccess: onSuccess,
    onFailure: onFailure,
    redirectURL: redirectURL
  })));
};

exports.LoginForm = LoginForm;

var getShadowUserId = /*#__PURE__*/function () {
  var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
    var val;
    return regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return _localforage.default.getItem('shadowUserId');

          case 2:
            val = _context.sent;
            return _context.abrupt("return", val);

          case 4:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function getShadowUserId() {
    return _ref2.apply(this, arguments);
  };
}();

var getShadowUserEmailHash = /*#__PURE__*/function () {
  var _ref3 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
    var val;
    return regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            _context2.next = 2;
            return _localforage.default.getItem('shadowUserHash');

          case 2:
            val = _context2.sent;
            return _context2.abrupt("return", val);

          case 4:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));

  return function getShadowUserEmailHash() {
    return _ref3.apply(this, arguments);
  };
}();

var getLastLoginEmail = /*#__PURE__*/function () {
  var _ref4 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
    var val;
    return regeneratorRuntime.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            _context3.next = 2;
            return _localforage.default.getItem('trc-last-login-email');

          case 2:
            val = _context3.sent;
            return _context3.abrupt("return", val);

          case 4:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3);
  }));

  return function getLastLoginEmail() {
    return _ref4.apply(this, arguments);
  };
}();

var setLastLoginEmail = function setLastLoginEmail(email) {
  _localforage.default.setItem('trc-last-login-email', email);
};